var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00016 9.91663C6.678 9.91663 6.41683 9.65546 6.41683 9.33329L6.41683 1.74996C6.41683 1.42779 6.678 1.16663 7.00016 1.16663C7.32233 1.16663 7.5835 1.42779 7.5835 1.74996L7.5835 9.33329C7.5835 9.65546 7.32233 9.91663 7.00016 9.91663Z",
    fill: "#00AEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74598 4.49577C9.51817 4.72358 9.14882 4.72358 8.92102 4.49577L7.00016 2.57492L5.07931 4.49577C4.8515 4.72358 4.48216 4.72358 4.25435 4.49577C4.02654 4.26797 4.02654 3.89862 4.25435 3.67081L6.58768 1.33748C6.81549 1.10967 7.18484 1.10967 7.41264 1.33748L9.74598 3.67081C9.97378 3.89862 9.97378 4.26797 9.74598 4.49577Z",
    fill: "#00AEEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91683 9.91663C3.239 9.91663 3.50016 10.1778 3.50016 10.5V11.6666H10.5002V10.5C10.5002 10.1778 10.7613 9.91663 11.0835 9.91663C11.4057 9.91663 11.6668 10.1778 11.6668 10.5V11.6666C11.6668 12.311 11.1445 12.8333 10.5002 12.8333H3.50016C2.85583 12.8333 2.3335 12.311 2.3335 11.6666V10.5C2.3335 10.1778 2.59466 9.91663 2.91683 9.91663Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadAttachment);
export default __webpack_public_path__ + "static/media/upload_attachment.828f67e70957d58c4aaae0be99f6a1d4.svg";
export { ForwardRef as ReactComponent };